import MasterDataTable from './MasterDataTable.vue';
export default {
  name: 'MpptStringMapPanel',
  components: {
    MasterDataTable: MasterDataTable
  },
  props: {
    def: {
      type: Object,
      required: true
    },
    siteCode: {
      type: String,
      default: ''
    }
  }
};